// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"266a6583","396":"63b42291","453":"9cdccfd2","468":"fbd198dc","620":"928b20f7","652":"3cb19787","668":"3c1573d8","738":"39feb3a9","803":"e53f23e2","879":"ff47ab17"}[chunkId] + ".chunk.js";
};